import { HelpData, HelpQuery, HelpQueryMessage } from "../../autogenerated/ZoomBridge";
import ErrorId from "../../protocol/ErrorId";

/**
 * QUery to get help based on help key
 * Created by Sarthak on 14/07/2023.
 */
export default class GetHelpQuery {

  static DEFAULT_PAGE_LENGTH = 1000;

  /**
   * 
   * @param {String} helpKey 
   * @param {number} pageLength 
   */
  constructor(helpKey: String, pageLength: number = GetHelpQuery.DEFAULT_PAGE_LENGTH): HelpQuery {
    this.helpKey = helpKey;
    this.pageLength = pageLength;
  }

  /**
   * 
   * @param {number} currentPage 
   * @returns 
   */
  run(currentPage: Number): Promise<> {
    return new Promise((onSuccess, onFailure) => {
      const query = new HelpQuery();
      const msg = new HelpQueryMessage();
      msg.setHelpKey(this.helpKey);
      msg.setCurrentPage(currentPage);
      msg.setPageLength(this.pageLength);
      query.message = msg;
      query.run().then(
        (helpResp: HelpData) => {
          onSuccess(helpResp);
        },
        (helpError: ErrorId) => {
          console.log("Help Error is : ", helpError ? helpError.toString() : "Unknown Error");
          onFailure(helpError);
        }
      );
    });
  }
}